<template>
  <div class="timeline">
    <slot></slot>
    <div class="split-line"></div>
  </div>
</template>
<script>
export default {
  name: 'Timeline',
  data(){
    return {}
  }
}
</script>
<style lang="scss" scoped>
@import "../common/theme.scss";
  .timeline {
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .split-line {
    width: 0;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-left:  1px dashed $themeColor;
    border-right: 1px dashed $themeColor;
  }
</style>
